import { BlockContainer, LoadingSkeleton, Table, getUserColumns } from '@components';
import { Box, Divider, Grid } from '@mui/material';
import { useMemo } from 'react';

export const DealerDetailsSkeleton = () => {
  const visibleColumnNames = getUserColumns().map((column) => column.key.toLowerCase());
  const filteredColumns = useMemo(
    () =>
      getUserColumns()?.filter((column) => visibleColumnNames?.includes(column.key.toLowerCase())),
    [visibleColumnNames]
  );

  return (
    <BlockContainer>
      <div className='dealer-details-block'>
        <LoadingSkeleton variant='text' height={80} />
        <Divider sx={{ mt: 1, mb: 4 }} />
      </div>

      <Box>
        <LoadingSkeleton variant='text' height={40} sx={{ mt: 5, mb: 2, maxWidth: 300 }} />
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LoadingSkeleton variant='text' height={40} sx={{ mt: 2 }} />
            <LoadingSkeleton variant='text' height={40} sx={{ mt: 2 }} />
            <LoadingSkeleton variant='text' height={40} sx={{ mt: 2 }} />
            <LoadingSkeleton variant='text' height={40} sx={{ mt: 2 }} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <LoadingSkeleton variant='text' height={40} sx={{ mt: 2 }} />
            <LoadingSkeleton variant='text' height={40} sx={{ mt: 2 }} />
            <LoadingSkeleton variant='text' height={40} sx={{ mt: 2 }} />
            <LoadingSkeleton variant='text' height={40} sx={{ mt: 2 }} />
          </Grid>
        </Grid>
      </Box>
      <Box>
        <LoadingSkeleton variant='text' height={30} sx={{ mt: 5, mb: 4, maxWidth: 300 }} />
        <Table
          isWorking={true}
          headerColumns={filteredColumns}
          itemsOnPage={5}
          renderRow={() => (
            <Box>
              <LoadingSkeleton variant='text' height={30} sx={{ my: 1, width: '100%' }} />
            </Box>
          )}
        />
      </Box>
    </BlockContainer>
  );
};
